export default "__VITE_ASSET__D0vs13KA__"